// FEAT-052 (#493): RAYConsent 연동 설정 (프런트 몫).
//
// **테넌트와 적재 토큰은 여기 없다.** 둘 다 `rayguard-api` 가 가진다.
//
// 왜 프런트가 테넌트를 고르지 않는가 —
//   RAYConsent 는 dev/prod 가 경로의 tenant_id 로 갈리고, 판 번호가 테넌트마다 자연히
//   달라진다(운영 v7 / 개발 v9). 프런트가 테넌트를 직접 판정하면 **화면에 띄운 판과 BE 가
//   기록하는 판이 어긋날 수 있다.** 그 순간 "이용자가 본 것"과 "기록된 것"이 다른
//   거짓 기록이 된다 — 동의 기록의 증거력이 바로 여기서 무너진다.
//   그래서 문구 조회도 BE 를 거친다. 테넌트를 아는 곳은 BE 한 군데뿐이다.
//
// CRA 는 `REACT_APP_*` 를 빌드 시점에 번들로 인라인하므로, 프런트에 둔 값은 환경변수로
// 주입해도 결과물이 공개된다(현재 iubenda 키 2개가 그 상태 — #481).

// 동의 대상 문서 식별자. BE 가 RAYConsent 에 조회할 때 쓴다.
export const CONSENT_TEXT_ID = 'privacy-policy';

// 🔴 현행 처리방침을 그대로 쓴다(2026-10-14 결정). 현행본은 **영문 1본뿐**이라 한국어 화면을
// 포함한 모든 이용자가 영문본을 본다. 국문본이 등록되면 'ko' 를 다시 넣고 분기를 되살린다.
//
// **기록의 locale 은 화면 언어가 아니라 「그 사람이 실제로 본 문서의 로케일」이어야 한다.**
// 독일어 화면에서 영문본을 봤다면 기록은 `de` 가 아니라 `en` 이다. 화면 언어를 그대로 적으면
// "독일어 방침에 동의했다"는 거짓 기록이 된다. (RAYTeams 홈페이지 실측 조언, 2026-10-07)
export const DOCUMENT_LOCALES = ['en'];

// 화면 언어를 인자로 받지만 지금은 쓰지 않는다 — 국문본 등록 시 `ko` 분기를 되살린다.
export const toDocumentLocale = () => 'en';

// 수집 지점 — 어느 화면에서 받았는지. 적재 시 그대로 보낸다.
export const COLLECTION_POINT_LOGIN = 'rayguard-web/login-consent-modal';

// 로그인 직후 흐름이라 길게 잡지 않는다 — 실패하면 폴백을 쓴다.
export const POLICY_FETCH_TIMEOUT_MS = 4000;
export const CONSENT_SUBMIT_TIMEOUT_MS = 8000;

// 직전 성공분 폴백 보관 키(브라우저 저장소). 이용자별 편의값이 아니라 **가용성 장치**이므로
// 없거나 읽기에 실패해도 화면이 동작해야 한다.
export const POLICY_CACHE_KEY_PREFIX = 'consentText:';
